import {IS_BROWSER} from '../../constants/environment'
import {get, pipe, pick} from '../../utils'

// Action Types

export const actionTypes = {
  UPDATE_FOOTER_HEIGHT: 'UPDATE_FOOTER_HEIGHT',
  UPDATE_GLOBAL_HEADER_HEIGHT: 'UPDATE_GLOBAL_HEADER_HEIGHT',
  UPDATE_IN_PAGE_NAV_HEIGHT: 'UPDATE_IN_PAGE_NAV_HEIGHT',
  UPDATE_WINDOW_SIZE: 'UPDATE_WINDOW_SIZE',
  UPDATE_WINDOW_SCROLL: 'UPDATE_WINDOW_SCROLL',
}

// Action Creators

const updateGlobalHeaderHeight = height => ({
  type: actionTypes.UPDATE_GLOBAL_HEADER_HEIGHT,
  payload: {height},
})

const updateInPageNavHeight = height => ({
  type: actionTypes.UPDATE_IN_PAGE_NAV_HEIGHT,
  payload: {height},
})

const updateFooterHeight = height => ({
  type: actionTypes.UPDATE_FOOTER_HEIGHT,
  payload: {height},
})

const updateWindowSize = win => ({
  type: actionTypes.UPDATE_WINDOW_SIZE,
  payload: win,
})

const updateWindowScroll = win => ({
  type: actionTypes.UPDATE_WINDOW_SCROLL,
  payload: win,
})

export const actionCreators = {
  updateGlobalHeaderHeight,
  updateInPageNavHeight,
  updateWindowSize,
  updateWindowScroll,
  updateFooterHeight,
}

// Selectors

const pickDimensions = pick(['innerWidth', 'innerHeight'])
const pickScroll = pick(['scrollY'])

const getEnvironment = get('environment')
const getGlobalHeaderHeight = pipe(getEnvironment, get('globalHeaderHeight'))
const getInPageNavHeight = pipe(getEnvironment, get('inPageNavHeight'))
const getFooterHeight = pipe(getEnvironment, get('footerHeight'))
const getWindow = pipe(getEnvironment, get('window'))
const getWindowSize = pipe(getWindow, pickDimensions)
const getWindowScroll = () => ({
  scrollY: IS_BROWSER
    ? window.scrollY || window.pageYOffset || document.documentElement.scrollTop
    : 0,
})
const getIsOldBrowser = pipe(getEnvironment, get('isOldBrowser'))

export const selectors = {
  getGlobalHeaderHeight,
  getInPageNavHeight,
  getFooterHeight,
  getWindowSize,
  getWindowScroll,
  getIsOldBrowser,
  pickDimensions,
  pickScroll,
}



// WEBPACK FOOTER //
// ./src/store/actions/environment.js